import React from "react";
import Flx from "../../../components/layout/Flx";
import PublicFormGrid from "../../../components/publicForm/PublicFormGrid";
import PublicFormSection from "../../../components/publicForm/PublicFormSection";
import RffAddressEditingField from "../../../components/finalForm/inputs/RffAddressEditingField";
import RffBooleanToggleField from "../../../components/finalForm/inputs/RffBooleanToggleField";
import RffDateOfBirthField from "../../../components/finalForm/inputs/RffDateOfBirthField";
import RffEmailField from "../../../components/finalForm/inputs/RffEmailField";
import RffPhoneField from "../../../components/finalForm/inputs/RffPhoneField";
import RffSelectField from "../../../components/finalForm/inputs/RffSelectField";
import RffSelectToggleField from "../../../components/finalForm/inputs/RffSelectToggleField";
import RffSsnField from "../../../components/finalForm/inputs/RffSsnField";
import RffTextField from "../../../components/finalForm/inputs/RffTextField";
import RffConditional from "../../../components/finalForm/shared/RffConditional";
import {
  CITIZENSHIP_OPTIONS,
  MARITAL_STATUS_OPTIONS,
  NAME_SUFFIX_OPTIONS,
} from "../creditAuthShared";

/**
 * Step 1 — everything the credit pull needs to identify the borrower.
 *
 * Nearly every field is required: a bureau match fails on partial identity data,
 * and a failed pull costs the borrower another round trip. middleName and
 * nameSuffix are the exceptions — plenty of people have neither.
 */
const StepCreditAuthDetails = () => (
  <Flx column>
    <PublicFormSection
      title="Your Name"
      description="Please enter your name exactly as it appears on your government issued ID."
    >
      <PublicFormGrid>
        <RffTextField required name="firstName" label="First Name" size={6} />
        <RffTextField required name="lastName" label="Last Name" size={6} />
        {/* Optional, but collecting them improves bureau name matching. */}
        <RffTextField
          name="middleName"
          label="Middle Name"
          helperText="Optional"
          size={6}
        />
        <RffSelectField
          name="nameSuffix"
          label="Suffix"
          helperText="Optional"
          options={NAME_SUFFIX_OPTIONS}
          size={6}
        />
      </PublicFormGrid>
    </PublicFormSection>

    <PublicFormSection title="Contact Information">
      <PublicFormGrid>
        <RffPhoneField required name="phone" label="Phone" size={6} />
        <RffEmailField required name="emailAddress" label="Email" size={6} />
      </PublicFormGrid>
    </PublicFormSection>

    <PublicFormSection
      title="Citizenship &amp; Identity"
      description="A credit report is pulled against this information, so it needs to match your records."
    >
      <PublicFormGrid>
        <RffSelectToggleField
          required
          name="citizenshipStatus"
          label="Please select your citizenship category"
          options={CITIZENSHIP_OPTIONS}
        />
        {/* The credit pull needs the address broken into
            streetNumber/streetName/city/state/zip, which this field produces —
            a plain text address would not be usable. */}
        <RffAddressEditingField
          required
          name="primaryAddress"
          label="Primary Address"
        />
        {/* No `size`: nothing shares this row, so it takes the full width. */}
        <RffDateOfBirthField
          required
          name="dateOfBirth"
          label="Date of birth"
        />
        <RffSelectToggleField
          required
          name="maritalStatus"
          size={6}
          label="What is your marital status?"
          options={MARITAL_STATUS_OPTIONS}
        />
        <RffBooleanToggleField
          required
          name="borrowerHasSSN"
          size={6}
          label="Do you have a US issued Social Security Number?"
        />
        <RffConditional field="borrowerHasSSN" value={true}>
          <RffSsnField
            required
            name="borrowerSSN"
            label="Social Security Number"
          />
        </RffConditional>
      </PublicFormGrid>
    </PublicFormSection>
  </Flx>
);

export default StepCreditAuthDetails;
